export { AppScreen as default } from '@/src/features/app/ui/AppScreen'
